import * as Sentry from "@sentry/react";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { TrpcProvider } from "./TrpcProvider";
import { initAnalytics } from "./analytics";
import { Router } from "./router";
import { initSentry } from "./sentry";
import "./index.css";

// Error + trace reporting. Safe in dev — no-op without a DSN.
initSentry();

// Fire-and-forget — no-op when VITE_POSTHOG_KEY is unset, so safe in dev.
initAnalytics();

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Root element not found");
}

createRoot(rootElement).render(
  <StrictMode>
    <Sentry.ErrorBoundary fallback={<p>Something went wrong.</p>}>
      <TrpcProvider>
        <Router />
      </TrpcProvider>
    </Sentry.ErrorBoundary>
  </StrictMode>,
);
